import development from "./development.environment";
import qa from "./qa.environment";
import production from "./production.environment";
import { Environment } from "@/types/environment";

let environment: Environment = production;

if (process.env.REACT_APP_ENV === "development") environment = development;
if (process.env.REACT_APP_ENV === "qa") environment = qa;

export default environment;
